import React from 'react'
import Educators from '../../components/EducationPages/Educators'

export default () => <Educators />
